export default __webpack_public_path__ + "static/media/man.9878f3aa.svg";